import { gql } from '@apollo/client';

export * from './escrowInvitationReject.mutation.generated';

export const ESCROW_INVITATION_REJECT = gql`
  mutation escrowInvitationReject($escrowInvitationId: ID!) {
    escrowInvitationReject(input: { escrowInvitationId: $escrowInvitationId }) {
      success
      errors
      escrowInvitation {
        ...EscrowInvitationFields
      }
    }
  }
`;
